import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DemoVideo from './components/DemoVideo';
import HowItWorks from './components/HowItWorks';
import ProblemSolution from './components/ProblemSolution';
import WorkshopFeatures from './components/WorkshopFeatures';
import Features from './components/Features';
import SuccessStory from './components/SuccessStory';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#0a1628] overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <DemoVideo />
        <HowItWorks />
        <ProblemSolution />
        <WorkshopFeatures />
        <Features />
        <SuccessStory />
        <Pricing />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
